// @ts-nocheck


import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import React, { Component } from 'react';
import { Popover } from 'antd';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import styled from 'styled-components';
import moment from 'moment';



import { Section } from './../../../../components/layout';
import { Table } from './../../../../components/ui';
import { InputNumber } from '../../../../components/inputs';
import Filter from './../../../Vehicles/Filter';
import { getListInitialState } from '../../../../lib/helpers';
import { vehicleApi } from './../../../../lib/api';
import { formatKopeiki } from '../../../../lib/helpers';

// В филиале в среднем 100 машин
const PAGE_SIZE = 100;

// Попытка оптимизировать рендеринг таблички
class PureCountInput extends React.PureComponent {
  render() {
    return <CountInput {...this.props} />;
  }
}

class PureFilter extends React.PureComponent {
  render() {
    return <Filter {...this.props} />;
  }
}

const CountInput = styled(InputNumber).withConfig({ displayName: "VehicleWashingList__CountInput", componentId: "sc-xwe55u-0" })(["margin-right:5px;width:50px;input{text-align:center;}.ant-input-number-handler-wrap{display:none;}"]);































export default class VehicleWashingList extends Component {
  state = {
    vehicles: {
      ...getListInitialState(),
      filter: {}
    },
    vehicleWashings: this.props.vehicleWashings
  };

  static defaultProps = {
    vehicleWashings: []
  };

  componentDidMount() {
    this.fetchVehicles();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.vehicleWashings, this.props.vehicleWashings)) {
      this.setState({
        vehicleWashings: this.props.vehicleWashings
      });
    }
  }

  columns = [
  {
    title: 'Гос. номер',
    dataIndex: 'vehicle.licensePlate',
    width: 70
  },
  {
    title: 'Марка',
    dataIndex: 'vehicle.vehicleModel.brandName',
    width: 60
  },
  {
    title: 'Модель',
    dataIndex: 'vehicle.vehicleModel.name',
    width: 90
  },
  {
    title: 'Наружная',
    dataIndex: 'bodyCount',
    width: 58,
    render: (bodyCount, record) =>
    <>
          <PureCountInput
        placeholder="0"
        value={bodyCount}
        onChange={(value) =>
        this.updateVehicleWashing('bodyCount', value, record)
        } />

        </>

  },
  {
    title: 'Салон',
    dataIndex: 'interiorCount',
    width: 58,
    render: (interiorCount, record) =>
    <PureCountInput
      placeholder="0"
      value={interiorCount}
      onChange={(value) =>
      this.updateVehicleWashing('interiorCount', value, record)
      } />


  },
  {
    title: 'ДВС',
    dataIndex: 'engineCount',
    width: 58,
    render: (engineCount, record) => {
      return (
        <PureCountInput
          placeholder="0"
          value={engineCount}
          onChange={(value) =>
          this.updateVehicleWashing('engineCount', value, record)
          } />);


    }
  },
  {
    title: 'Стоимость',
    width: 70,
    render: (record) => {
      let total = 0;

      let rows = [];
      let row;
      let rowTotal;

      if (record) {
        if (record.bodyPrice) {
          row = `Наружная ${formatKopeiki(record.bodyPrice)}`;

          // проверки для слабаков
          // $FlowFixMe
          if (record.bodyCount && record.bodyPrice) {
            rowTotal = record.bodyCount * record.bodyPrice;
            total += rowTotal;
            row = `Наружная ${record.bodyCount} x ${formatKopeiki(
              record.bodyPrice
            )} = ${formatKopeiki(rowTotal)}`;
          }

          rows.push(row);
        }

        if (record.enginePrice) {
          row = `Двигатель ${formatKopeiki(record.enginePrice)}`;

          //$FlowFixMe
          if (record.engineCount && record.enginePrice) {
            rowTotal = record.engineCount * record.enginePrice;
            total += rowTotal;

            row = `Двигатель ${record.engineCount} x ${formatKopeiki(
              record.enginePrice
            )} = ${formatKopeiki(rowTotal)}`;
          }

          rows.push(row);
        }

        if (record.interiorPrice) {
          row = `Салон ${formatKopeiki(record.interiorPrice)}`;

          //$FlowFixMe
          if (record.interiorCount && record.interiorPrice) {
            rowTotal = record.interiorCount * record.interiorPrice;
            total += rowTotal;

            row = `Салон ${record.interiorCount} x ${formatKopeiki(
              record.interiorPrice
            )} = ${formatKopeiki(rowTotal)}`;
          }

          rows.push(row);
        }
      }

      let iconComponent =
      <InfoCircleOutlined style={{ color: '#0000FF' }} />;

      if (rows.length === 0) {
        rows.push('Нет данных');
        iconComponent = <WarningOutlined style={{ color: '#FAAD14' }} />;
      }

      let popoverContent =
      <div>
            {rows.map((r, i) =>
        <p key={i}>{r}</p>
        )}
          </div>;

      return (
        <div>
            {formatKopeiki(total)}&nbsp;
            <Popover content={popoverContent} title="Прейскурант">
              {iconComponent}
            </Popover>
          </div>);

    }
  },
  {
    title: 'Подразделение',
    dataIndex: 'vehicle.orgUnitName'
  }];


  fetchVehicles = async (
  page = 1,
  params = {}) =>
  {
    try {
      const { filter } = this.state.vehicles;
      this.updateVehiclesInfo({ loading: true });

      const { data, totalCount } = await vehicleApi.fetchVehiclesForWashingPlan(
        {
          ...filter,
          page,
          ...params,
          ownerType: 'self',
          pageSize: PAGE_SIZE
        },
        this.props.planDate ?
        moment(this.props.planDate).toISOString() :
        moment.utc().toISOString()
      );
      this.updateVehiclesInfo({ data, totalCount, page });
    } catch (err) {
    } finally {
      this.updateVehiclesInfo({ loading: false });
    }
  };

  syncData = debounce(
    () => this.props.onChange(this.state.vehicleWashings),
    500
  );

  cleanFilter = () =>
  this.updateVehiclesInfo({ filter: {} }, this.fetchVehicles);

  applyFilter = (filter) =>
  this.updateVehiclesInfo({ filter }, this.fetchVehicles);

  updateVehiclesInfo = (newValues, cb) =>
  this.setState(
    (prevState) => ({
      vehicles: {
        ...prevState.vehicles,
        ...newValues
      }
    }),
    cb
  );

  updateVehicleWashing = async (
  key,
  value,
  washingVehicle) =>
  {
    let vehicleWashings = [...this.state.vehicleWashings];
    const index = vehicleWashings.findIndex(
      (item) => item.vehicleId === washingVehicle.vehicleId
    );
    if (index >= 0) {
      vehicleWashings.splice(index, 1, {
        ...vehicleWashings[index],
        [key]: value
      });
    } else {
      vehicleWashings = [
      ...vehicleWashings,
      {
        ...washingVehicle,
        [key]: value
      }];

    }

    this.setState(
      {
        vehicleWashings
      },
      () => {
        this.syncData();
      }
    );
  };

  mapVehicleToWashingPlan = (vehicles) => {
    const { vehicleWashings } = this.state;
    return vehicles.map(
      (vehicle) => ({
        // Специально выставил вперед, чтобы не джоинить ТС на сервере
        ...vehicleWashings.find(
          (item) => item.vehicleId === vehicle.id
        ),
        vehicle,
        vehicleId: vehicle.id,
        bodyPrice: vehicle.bodyPrice,
        interiorPrice: vehicle.interiorPrice,
        enginePrice: vehicle.enginePrice
      })
    );
  };

  render() {
    const { vehicles } = this.state;
    const { filter, data, loading, page, totalCount } = vehicles;
    return (
      <Section>
        <PureFilter
          filter={filter}
          cleanFilter={this.cleanFilter}
          applyFilter={this.applyFilter} />

        <Table
          columns={this.columns}
          scroll={{ y: 800 }}
          fetch={this.fetchVehicles}
          rowKey="vehicleId"
          data={this.mapVehicleToWashingPlan(data)}
          loading={loading}
          pagination={{
            page,
            totalCount,
            pageSize: PAGE_SIZE
          }} />

      </Section>);

  }
}
